import React from 'react';
import { HashRouter as Router, Route, Switch } from 'react-router-dom';
import './App.css';
import Artefacts from './Artefacts';
import ControlFlexibility from './ControlFlexibility';
import Evaluation from './Evaluation';
import Home from './Home';
import Paper from './Paper';
import Plots from './Plots';

const App = () => {
	return (
		<Router basename="/">
			<div
				style={{
					display: 'flex',
					flexDirection: 'column',
					justifyContent: 'center',
					width: '100vw',
					overscrollBehaviorX: 'none',
					overflowX: 'hidden',
					touchAction: 'manipulation',
				}}
			>
				<Switch>
					<Route path="/controlflexibility">
						<ControlFlexibility></ControlFlexibility>
					</Route>
					<Route path="/artefacts" component={Artefacts}></Route>
					<Route path="/evaluation">
						<Evaluation></Evaluation>
					</Route>
					<Route path="/paper">
						<Paper></Paper>
					</Route>
					<Route path="/plots">
						<Plots></Plots>
					</Route>
					<Route path="/">
						<Home></Home>
					</Route>
				</Switch>
			</div>
		</Router>
	);
};

export default App;
